import React from "react";
import ai from "../../images/Assets/ai.png";
import integrate from "../../images/Assets/integrate.png";
import support from "../../images/Assets/support.png";

export default function Service() {
  return (
    <div className="md:px-6 xl:px-10 px-28 pt-4 pb-20">
      <div className="flex items-center justify-center">
        <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
          Our Services
        </div>
      </div>

      <div className="md:text-[28px] text-[40px] text-[#0E062A] text-center font-gilroySemibold mt-2">
        Empowering Your AI Journey
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 grid-cols-3 gap-5 mt-8">
        <div className="flex flex-col items-center justify-center bg-[#FBFAFE] border border-[#F1ECFF] px-5 py-5 rounded-2xl">
          <img src={ai} alt="ai" className="w-[160px] h-[160px]" />

          <div className="lg:text-[22px] text-[24px] text-center text-[#0E062A] font-gilroySemibold mt-3">
            Custom AI Development
          </div>

          <div className="lg:text-[16px] text-[18px] text-center text-[#544D68] font-gilroyRegular mt-3">
            Whether you need machine learning models, natural language processing, predictive analytics, or
            any other AI tech, we’ve got you covered. We develop AI solutions tailored to your specific
            business needs.
          </div>
        </div>
        <div className="flex flex-col items-center justify-center bg-[#FBFAFE] border border-[#F1ECFF] px-5 py-5 rounded-2xl">
          <img src={integrate} alt="integrate" className="w-[160px] h-[160px]" />

          <div className="lg:text-[22px] text-[24px] text-center text-[#0E062A] font-gilroySemibold mt-3">
            AI Integration
          </div>

          <div className="lg:text-[16px] text-[18px] text-center text-[#544D68] font-gilroyRegular mt-3">
            Already have existing systems? We ensure your new AI solution integrates smoothly with your
            current software and processes.
          </div>
        </div>
        <div className="flex flex-col items-center justify-center bg-[#FBFAFE] border border-[#F1ECFF] px-5 py-5 rounded-2xl">
          <img src={support} alt="support" className="w-[160px] h-[159px]" />

          <div className="lg:text-[22px] text-[24px] text-center text-[#0E062A] font-gilroySemibold mt-3">
            Ongoing Support and Training
          </div>

          <div className="lg:text-[16px] text-[18px] text-center text-[#544D68] font-gilroyRegular mt-3">
            AI is always evolving, and so are we. We provide ongoing support and training to keep you ahead of
            the curve.
          </div>
        </div>
      </div>
    </div>
  );
}
